import React from 'react';
import { ieCheck } from '../../helpers/utils';


const ResponsiveImage = (props) => {

  const imageObj = {
    quality:props.quality,
    src:(props.src === undefined || props.src === "") ? "" : props.src,
    width:props.width,
    widthRetina:props.widthRetina,
    alt:props.alt,
    clazz:props.clazz  === undefined ? "" : props.clazz,
    lazyload:props.lazyload === undefined ? true : props.lazyload
  }


  const standardImg = () => {
    return (
        <img
          alt={`${imageObj.alt}`}
          data-srcset={`https:${imageObj.src}?w=${imageObj.width}&q=${imageObj.quality} 1x, https:${imageObj.src}?w=${imageObj.widthRetina}&q=${imageObj.quality} 2x`}
          data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          className={`lazyload ${imageObj.clazz}`}/>
    )
  }

  const ieImg = () => {
    return (
      <img className={`${imageObj.clazz}`} alt={`${imageObj.alt}`} src={`https:${imageObj.src}?w=${imageObj.width}&q=${imageObj.quality}`} />
    )
  }

  return  (ieCheck() || !imageObj.lazyload) ? ieImg() : standardImg();

}

export default ResponsiveImage;
